import React, {FC} from 'react';

import {Colors, Input, Text} from '@optimaxdev/design-system';

import classNames from 'classnames';

import {validateField} from 'libs/success/helpers/helpers';
import {DoctorDetailsType} from 'types/successPage';

import {DoctorManualSearchContacts} from '../doctorManuallySearchContacts/doctorManualSearchContacts';
import {DoctorManualSearchRegion} from '../doctorManuallySearchRegion/doctorManualSearchRegion';

import s from './doctorManualSearch.scss';

const getInputs = (
    isDesktop: boolean,
): Array<{
    name: 'patientName' | 'name';
    label: string;
    title: string;
}> => [
    {
        label: 'Patient Name',
        name: 'patientName',
        title: 'Who this prescription for:',
    },
    {
        label: 'Eye doctor / Clinic name',
        name: 'name',
        title: `Doctor/clinic details${isDesktop ? ' (Enter at least one):' : ':'}`,
    },
];

export type PropsType = {
    doctorDetails: DoctorDetailsType;
    onDoctorDetailsChange: (name: string, value: string) => void;
    handleExamClick: () => void;
    isVista?: boolean;
    errors: {[key: string]: string};
};

/**
 * Doctor manual search form for TYP CL
 */
export const DoctorManualSearch: FC<PropsType> = ({
    doctorDetails,
    errors,
    handleExamClick,
    isVista,
    onDoctorDetailsChange,
}) => {
    const isDesktop = __BUILD_TYPE__ === 'desktop';

    return (
        <>
            <Text
                as="p"
                color={Colors.limedSpruce}
                lineHeight="24px"
                margin={isDesktop ? '0 0 2px 0' : '0'}
                size="16px"
                bold
            >
                Enter Your eye doctor/clinic details
            </Text>
            <Text as="p" color={Colors.limedSpruce} lineHeight="24px" margin="0 0 13px" size="16px">
                We’ll quickly verify your prescription with your doctor to ensure you will get the
                exact contact lenses you need.
            </Text>
            {getInputs(isDesktop).map(item => {
                const value = doctorDetails[item.name] || '';

                const error = errors?.[item.name] || '';
                const isSuccess = validateField(item.name, value);

                return (
                    <label
                        className={classNames(s.label, {
                            [s.desktop]: isDesktop,
                            [s.marginBottom]: isDesktop && item.name !== 'name',
                        })}
                        htmlFor={item.name}
                        key={item.name}
                    >
                        <Text color={Colors.nevada} lineHeight="21px" size="14px">
                            {item.title}
                        </Text>
                        <div>
                            <Input
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                    onDoctorDetailsChange(event.target.name, event.target.value)
                                }
                                id={item.name}
                                isError={Boolean(error)}
                                isSuccess={isSuccess}
                                label={item.label}
                                message={error}
                                name={item.name}
                                size="large"
                                value={value}
                                isRequired
                            />
                        </div>
                    </label>
                );
            })}
            <div className={classNames(s.form, {[s.desktop]: isDesktop})}>
                <DoctorManualSearchRegion
                    doctorDetails={doctorDetails}
                    errors={errors}
                    onDoctorDetailsChange={onDoctorDetailsChange}
                />
                <DoctorManualSearchContacts
                    doctorDetails={doctorDetails}
                    errors={errors}
                    onDoctorDetailsChange={onDoctorDetailsChange}
                />
                {!isVista && (
                    <button onClick={handleExamClick} type="button">
                        <Text color={Colors.nevada} lineHeight="21px" size="14px" underline>
                            My prescription isn&apos;t valid, I need to renew it
                        </Text>
                    </button>
                )}
            </div>
        </>
    );
};
